import React from 'react';

export function CreatePackagingPOV2() {
    return (
        <div className="flex min-h-screen flex-col">
            <div className="px-4 pt-4">
                <h1 className="text-xl font-semibold">Create Packaging Purchase Order V2</h1>
            </div>
            <div className="flex flex-1 flex-col px-4 pb-6 pt-4">
                <div className="rounded-md border border-dashed border-muted-foreground/30 p-6 text-sm text-muted-foreground">
                    Placeholder page for the packaging PO v2 create flow.
                </div>
            </div>
        </div>
    );
}

CreatePackagingPOV2.displayName = 'CreatePackagingPOV2';
